/* Back9Lab tussenversie: feedback Donny 13 okt (Site improvements.docx). Laadt na b9-extra.js. */

/* 1. Tweekleurige koppen: altijd het zwaarste woord (zelfde regels als snippet b9-accent) */
(function () {
  var SKIP = '|WHAT|WHY|HOW|OUR|THE|A|AN|SEE|YOU|MAY|ALSO|ALL|FREQUENTLY|ASKED|SHOP|NEW|FINALLY|MEET|DISCOVER|EXPLORE|YOUR|FOR|OF|AND|&|WITH|THAT|IS|ARE|TO|IN|ON|BY|GOLFERS|SAY|RECENTLY|GOLF|';
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function range(words) {
    var n = words.length, i, from = -1, to = -1;
    for (i = 0; i < n - 1; i++) {
      if (words[i].toUpperCase() === 'ABOUT') { from = i + 1; if (words[from].toUpperCase() === 'OUR' && from < n - 1) from++; to = n - 1; }
    }
    if (from < 0) {
      for (i = 0; i < n; i++) {
        if (words[i].indexOf('™') > -1) {
          from = to = i;
          for (var k = i - 1; k >= 0 && k >= i - 4; k--) { var c = words[k].charAt(0); if (c !== c.toLowerCase() && c === c.toUpperCase()) from = k; else break; }
          break;
        }
      }
    }
    if (from < 0) for (i = 0; i < n; i++) if (SKIP.indexOf('|' + words[i].toUpperCase() + '|') < 0) { from = to = i; break; }
    if (from < 0) from = to = n - 1;
    return [from, to];
  }
  function apply(h) {
    var t = (h.textContent || '').trim().replace(/\s+/g, ' ');
    if (!t || t.length > 90) return;
    var up = t.toUpperCase(), words = t.split(' ');
    if (up === 'BESTSELLERS') { h.innerHTML = '<span class="b9-accent">' + esc(t.slice(0, 4)) + '</span>' + esc(t.slice(4)); return; }
    if (words.length === 1) { h.innerHTML = '<span class="b9-accent">' + esc(t) + '</span>'; return; }
    var r = range(words);
    h.innerHTML = words.map(function (w, i) {
      return (i === r[0] ? '<span class="b9-accent">' : '') + esc(w) + (i === r[1] ? '</span>' : '');
    }).join(' ');
  }
  function run() {
    document.querySelectorAll('.b9-accent').forEach(function (s) {
      var h = s.parentElement;
      if (!h || h.dataset.b9acc2 || h.querySelectorAll('.b9-accent').length !== 1) return;
      if ([].some.call(h.children, function (c) { return !c.classList.contains('b9-accent'); })) return;
      h.dataset.b9acc2 = 1;
      apply(h);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();

/* 2. PDP: foto's in vaste volgorde (Liquid); gekozen variant geselecteerd en thumbnail in beeld. Andere kleurfoto aanklikken = kleur springt mee. */
(function () {
  var s = document.getElementById('Product-Slider');
  if (!s) return;
  var t = document.getElementById('Product-Thumbnails');
  var userMoved = false;
  if (t) ['wheel', 'touchstart', 'pointerdown'].forEach(function (ev) { t.addEventListener(ev, function () { userMoved = true; }, { passive: true }); });
  function center() {
    if (userMoved || !t) return;
    var q = t.querySelector('.product-thumbnail.is-initial-selected');
    if (!q || !q.previousElementSibling || !t.clientHeight) return;
    var r = q.getBoundingClientRect(), c = t.getBoundingClientRect();
    t.scrollTo({ top: t.scrollTop + r.top - c.top - (t.clientHeight - q.clientHeight) / 2, left: t.scrollLeft + r.left - c.left - (t.clientWidth - q.clientWidth) / 2, behavior: 'instant' });
  }
  center(); requestAnimationFrame(center);
  if (document.readyState === 'complete') { center(); } else window.addEventListener('load', function () { center(); setTimeout(center, 300); });

  var vs = document.querySelector('variant-selects:not(.variant-selects--sticky)');
  var data = null;
  try { data = JSON.parse(vs.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }
  var sec = vs.dataset.section;
  function currentVariant() {
    var inp = document.querySelector('#product-form-' + sec + ' input[name="id"], form[id^="product-form-' + sec + '"] [name="id"]');
    var id = inp && String(inp.value);
    return data.filter(function (v) { return String(v.id) === id; })[0] || null;
  }
  function setOptions(v) {
    var sets = [].slice.call(vs.querySelectorAll('fieldset'));
    v.options.forEach(function (o, i) {
      var fs = sets[i]; if (!fs) return;
      var sel = fs.querySelector('select');
      if (sel) { if (sel.value !== o) { sel.value = o; sel.dispatchEvent(new Event('change', { bubbles: true })); } return; }
      var r = [].filter.call(fs.querySelectorAll('input[type=radio]'), function (x) { return x.value === o; })[0];
      if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }
  function onChange(index) {
    var f = window.Flickity && Flickity.data(s); if (!f || !f.cells[index]) return;
    var el = f.cells[index].element, m = (el.getAttribute('data-media-id') || '').match(/-(\d+)$/);
    if (!m) return;
    var mid = Number(m[1]), cur = currentVariant();
    if (cur && cur.featured_media && cur.featured_media.id === mid) return;
    var cands = data.filter(function (v) { return v.featured_media && v.featured_media.id === mid; });
    if (!cands.length) return; /* lifestyle- of detailfoto: kleur blijft staan */
    function score(v) {
      var sc = v.available ? 100 : 0;
      if (cur) v.options.forEach(function (o, i) { if (o === cur.options[i]) sc += 1; });
      return sc;
    }
    cands.sort(function (a, b) { return score(b) - score(a); });
    setOptions(cands[0]);
  }
  var tries = 0;
  (function hook() {
    var f = window.Flickity && Flickity.data(s);
    if (!f) { if (tries++ < 60) setTimeout(hook, 200); return; }
    if (s.b9Hooked) return; s.b9Hooked = true;
    f.on('change', onChange);
  })();
})();

/* 3. Cart (Rebuy): Buy 2, get 1 free op polo's met vakjes zoals HeadCaddy. Voor Black Friday: B9_BOGO.match uitbreiden naar riemen. */
(function () {
  var CFG = window.B9_BOGO || { match: /\bpolo\b/i, one: 'polo', many: 'polos', shop: '/collections/golf-polos', shopLabel: 'Shop polos' };
  var DISC = /buy 2 get 1|b2g1|bogo/i;
  var count = null, timer = null, busy = false;
  var ICON = '<svg viewBox="0 0 32 32" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M11 5l-6 3-2 7 4 1.5V27h18V16.5L29 15l-2-7-6-3c-.8 1.8-2.7 3-5 3s-4.2-1.2-5-3z"/><path d="M14 8.6V12l2 1.5 2-1.5V8.6"/></svg>';
  function eligible(cart) {
    var a = 0, b = 0;
    (cart.items || []).forEach(function (i) {
      var d = (i.discounts || []).map(function (x) { return x.title || ''; }).join(' ');
      if (DISC.test(d)) a += i.quantity;
      if (CFG.match.test(i.product_title || i.title || '')) b += i.quantity;
    });
    return Math.max(a, b);
  }
  function html() {
    var n = count || 0, r = n % 3, sets = Math.floor(n / 3), msg, note;
    var shop = '<a href="' + CFG.shop + '">' + CFG.shopLabel + '</a>';
    if (n === 0) { msg = "Don't forget: <b>Buy 2 " + CFG.many + ', get 1 free</b>'; note = 'Mix &amp; match any styles. ' + shop; }
    else if (r === 1) { msg = 'Add 1 more ' + CFG.one + ' and <b>get 1 free</b>'; note = 'Mix &amp; match any styles. ' + shop; }
    else if (r === 2) { msg = '<b>Your free ' + CFG.one + ' is waiting</b>, add 1 more'; note = 'Applied automatically in your cart.'; }
    else { msg = '<b>' + sets + ' free ' + (sets > 1 ? CFG.many : CFG.one) + ' unlocked</b>'; note = 'Add 2 more to get another one free. ' + shop; }
    var filled = r === 0 && n > 0 ? 3 : r;
    var li = [0, 1, 2].map(function (i) {
      var on = i < filled, free = i === 2, cls = (on ? 'is-on' : '') + (free ? ' is-free' : ''), inner;
      if (free) inner = on ? ICON + '<span>FREE</span>' : (r === 2 ? '<span>Add 1 FREE ' + CFG.one + '</span><a href="' + CFG.shop + '">' + CFG.shopLabel + '</a>' : ICON + '<span>FREE</span>');
      else inner = ICON + '<span>' + (i + 1) + (i ? 'nd ' : 'st ') + CFG.one + '</span>';
      return '<li class="' + cls.trim() + '">' + inner + '</li>';
    }).join('');
    return '<p class="b9-bogo__msg">' + msg + '</p><ul class="b9-bogo__steps">' + li + '</ul><p class="b9-bogo__note">' + note + '</p>';
  }
  function render() {
    var fly = document.querySelector('.rebuy-cart__flyout');
    if (!fly || count === null) return;
    var box = fly.querySelector('.b9-bogo');
    if (!box) {
      box = document.createElement('div'); box.className = 'b9-bogo'; box.setAttribute('aria-live', 'polite');
      var anchor = fly.querySelector('.rebuy-cart__progress-bar-wrapper'), host = anchor ? anchor.parentElement : null;
      if (host && host.parentElement) host.parentElement.insertBefore(box, host.nextSibling);
      else { var item = fly.querySelector('.rebuy-cart__flyout-item'), list = item && item.closest('ul'); if (list && list.parentElement) list.parentElement.insertBefore(box, list); else return; }
    }
    var h = html();
    if (box.getAttribute('data-h') !== h) { box.innerHTML = h; box.setAttribute('data-h', h); }
  }
  function load() {
    if (busy) return; busy = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); })
      .then(function (c) { busy = false; count = eligible(c); render(); }).catch(function () { busy = false; });
  }
  function bump() { clearTimeout(timer); timer = setTimeout(load, 350); }
  var f = window.fetch;
  if (f) window.fetch = function (u) { var url = typeof u === 'string' ? u : (u && u.url) || '', p = f.apply(this, arguments); if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(bump, bump); return p; };
  var o = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) { if (/\/cart\/(add|change|update|clear)/.test(u || '')) this.addEventListener('loadend', bump); return o.apply(this, arguments); };
  ['rebuy:cart.change', 'rebuy:cart.ready', 'rebuy:smartcart.show', 'rebuy:smartcart.ready'].forEach(function (e) { document.addEventListener(e, bump); });
  new MutationObserver(function () { var fly = document.querySelector('.rebuy-cart__flyout'); if (fly && !fly.querySelector('.b9-bogo')) render(); })
    .observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', load); else load();
})();

/* 4. Mega menu: fototegels vooraf laden zodat ze niet haperen bij openen (zoals HeadCaddy) */
(function () {
  var done = false;
  function warm() {
    if (done) return; done = true;
    document.querySelectorAll('.b9-mega__img img, .thb-full-menu img[loading="lazy"], .mobile-menu img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager'; img.decoding = 'async';
      if (img.decode) img.decode().catch(function () {});
    });
  }
  function idle() { (window.requestIdleCallback || function (cb) { setTimeout(cb, 300); })(warm, { timeout: 2500 }); }
  if (document.readyState === 'complete') idle(); else window.addEventListener('load', idle);
  ['mouseover', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (e.target && e.target.closest && e.target.closest('header, .header, theme-header, .mobile-toggle-wrapper')) warm(); }, { passive: true, capture: true });
  });
})();

/* 5. Snelkoppeling (Choose options): Sizing guide met de size chart van het product zelf (template product.b9size) */
(function () {
  var url = null, cache = {};
  document.addEventListener('click', function (e) {
    var q = e.target.closest && e.target.closest('product-card quick-view, product-card .product-card-quickview, product-card [data-quick-view]');
    if (!q) return;
    var a = q.closest('product-card').querySelector('a.product-card-title');
    url = a ? (a.getAttribute('href') || '').split('?')[0] : null;
  }, true);
  function fill(op) {
    if (!url || op.dataset.b9sg) return;
    op.dataset.b9sg = '1';
    var btn = op.querySelector('button'), id = op.getAttribute('data-modal');
    var p = cache[url] || (cache[url] = fetch(url + '?view=b9size', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }).catch(function () { return ''; }));
    p.then(function (h) {
      h = (h || '').trim();
      if (!h) { op.style.display = 'none'; return; }
      var ms = document.querySelectorAll(id), m = ms[ms.length - 1];
      if (!m) return;
      var tmp = document.createElement('div'); tmp.innerHTML = h;
      var h5 = m.querySelector('.product-popup-modal__content-header h5'), info = m.querySelector('.product-popup-modal__content-info');
      if (h5 && tmp.querySelector('h5')) h5.textContent = tmp.querySelector('h5').textContent;
      if (info && tmp.querySelector('.b9-sg')) info.innerHTML = tmp.querySelector('.b9-sg').innerHTML;
      var dlg = m.querySelector('[role=dialog]'); if (dlg) dlg.setAttribute('aria-label', 'Sizing guide');
      var sp = btn && btn.querySelector('span');
      if (sp && !sp.textContent.trim()) sp.textContent = 'Sizing guide';
      op.classList.add('b9-sg-ready');
    });
  }
  new MutationObserver(function () {
    var c = document.getElementById('Product-Drawer-Content'); if (!c) return;
    c.querySelectorAll('.product-popup-modal__opener:not([data-b9sg])').forEach(fill);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 6. Kaartfoto's: snel doorklikken zonder flits van een andere kleur (Donny 13 okt). Pijlen tellen vanaf het doel, niet vanaf de tussenstand van de animatie, en de volgende foto's laden vooraf. */
(function () {
  function warm(tr, from, to) {
    for (var k = from; k <= to; k++) {
      var s = tr.children[k], img = s && s.querySelector('img');
      if (img && img.loading === 'lazy') img.loading = 'eager';
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.b9-cs-prev, .b9-cs-next');
    if (!b) return;
    var cs = b.closest('.b9-cs'), tr = cs && cs.querySelector('.b9-cs-track');
    if (!tr) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var n = tr.children.length, w = Math.max(tr.clientWidth, 1);
    if (!n) return;
    var cur = (tr.b9T != null && Date.now() - tr.b9Tt < 800) ? tr.b9T : Math.round(tr.scrollLeft / w);
    var i = cur + (b.classList.contains('b9-cs-next') ? 1 : -1);
    i = (i % n + n) % n;
    tr.b9T = i; tr.b9Tt = Date.now();
    warm(tr, Math.max(0, i - 1), Math.min(n - 1, i + 2));
    tr.scrollTo({ left: i * w, behavior: 'smooth' });
  }, true);
  ['mouseover', 'touchstart'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var card = e.target.closest && e.target.closest('product-card');
      var tr = card && card.querySelector('.b9-cs-track');
      if (!tr || tr.b9Warm) return;
      tr.b9Warm = true;
      warm(tr, 0, Math.min(tr.children.length - 1, 3));
    }, { passive: true, capture: true });
  });
})();

/* 7. Reviewblok (ss-testimonial-8) in huisstijl, zoals HeadCaddy (Donny 13 okt): donkergroen, links score en aantal, rechts kaarten als slider. Inhoud komt uit de bestaande sectie. */
(function () {
  var CSS = '.b9-rev{background:#1A2A26;color:#fff;padding:64px 0;font-family:Inter,sans-serif}.b9-rev__in{max-width:1280px;margin:0 auto;padding:0 24px}.b9-rev__h{margin:0 0 36px;text-align:center;color:#fff!important;font-size:clamp(26px,3vw,38px);line-height:1.2;font-weight:700}.b9-rev__h .b9-accent{color:#A4B49D!important;background:none!important;box-shadow:none!important}.b9-rev__grid{display:grid;grid-template-columns:270px minmax(0,1fr);gap:40px;align-items:center}.b9-rev__sum{text-align:left}.b9-rev__score{display:flex;align-items:baseline;gap:8px}.b9-rev__num{font-size:64px;font-weight:700;line-height:1}.b9-rev__of{font-size:22px;font-weight:600;color:#A4B49D}.b9-rev__stars{display:flex;gap:4px;margin:12px 0 10px}.b9-rev__stars svg{width:24px;height:24px;display:block}.b9-rev__based{margin:0;font-size:16px;color:rgba(255,255,255,.85)}.b9-rev__based strong{color:#fff}.b9-rev__golfers{margin:22px 0 0;padding-top:20px;border-top:1px solid rgba(164,180,157,.35);font-size:16px;line-height:1.45;color:rgba(255,255,255,.85)}.b9-rev__golfers strong{color:#A4B49D}.b9-rev__slider{position:relative;min-width:0}.b9-rev__track{display:flex;gap:16px;overflow-x:auto;scroll-snap-type:x mandatory;scrollbar-width:none;-webkit-overflow-scrolling:touch;padding:4px 2px}.b9-rev__track::-webkit-scrollbar{display:none}.b9-rev__card{flex:0 0 calc((100% - 32px)/3);scroll-snap-align:start;box-sizing:border-box;background:#fff;color:#1A2A26;border-radius:16px;padding:22px 22px 18px;display:flex;flex-direction:column}.b9-rev__card .b9-rev__stars{margin:0 0 12px}.b9-rev__card .b9-rev__stars svg{width:18px;height:18px}.b9-rev__t{margin:0 0 8px;font-size:17px;font-weight:700;line-height:1.3;color:#1A2A26}.b9-rev__x{margin:0 0 16px;font-size:15px;line-height:1.55;color:#333}.b9-rev__a{margin:auto 0 0;padding-top:12px;border-top:1px solid #EDEDED;font-size:14px;font-weight:700;color:#1A2A26}.b9-rev__nav{display:flex;justify-content:flex-end;gap:10px;margin-top:16px}.b9-rev__btn{width:44px;height:44px;border-radius:50%;border:1.5px solid #A4B49D;background:transparent;color:#A4B49D;display:flex;align-items:center;justify-content:center;cursor:pointer;padding:0}.b9-rev__btn:hover{background:#A4B49D;color:#1A2A26}.b9-rev__btn svg{width:18px;height:18px}@media (max-width:989px){.b9-rev__grid{grid-template-columns:1fr;gap:28px}.b9-rev__sum{text-align:center}.b9-rev__score,.b9-rev__stars{justify-content:center}.b9-rev__card{flex-basis:calc((100% - 16px)/2)}}@media (max-width:767px){.b9-rev{padding:44px 0}.b9-rev__in{padding:0 16px}.b9-rev__card{flex-basis:86%}.b9-rev__num{font-size:52px}.b9-rev__nav{justify-content:center}}';
  var STAR = '<svg viewBox="0 0 20 20" aria-hidden="true"><path fill="#EBBF1F" d="M10 1.7l2.5 5.2 5.7.8-4.1 4 1 5.7L10 14.7l-5.1 2.7 1-5.7-4.1-4 5.7-.8z"/></svg>';
  function stars(r, id) {
    var out = '';
    for (var i = 1; i <= 5; i++) {
      var f = Math.max(0, Math.min(1, r - (i - 1)));
      if (f >= 0.99) out += STAR;
      else if (f <= 0.01) out += STAR.replace('#EBBF1F', 'rgba(255,255,255,.25)');
      else { var g = id + i; out += '<svg viewBox="0 0 20 20" aria-hidden="true"><defs><linearGradient id="' + g + '"><stop offset="' + Math.round(f * 100) + '%" stop-color="#EBBF1F"/><stop offset="' + Math.round(f * 100) + '%" stop-color="rgba(255,255,255,.25)"/></linearGradient></defs><path fill="url(#' + g + ')" d="M10 1.7l2.5 5.2 5.7.8-4.1 4 1 5.7L10 14.7l-5.1 2.7 1-5.7-4.1-4 5.7-.8z"/></svg>'; }
    }
    return out;
  }
  function esc(s) { return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function build(sec, n) {
    if (sec.dataset.b9rev) return;
    var src = sec.querySelector('[class*="testimonials-template"], [class^="section-template"]'); if (!src) return;
    var h = sec.querySelector('h2'), numEl = sec.querySelector('[class*="testimonials-rating-"] > span'), cntEl = sec.querySelector('[class*="testimonials-text-"] strong');
    var r = parseFloat((numEl && numEl.textContent || '').replace(',', '.')); if (!(r > 0)) return;
    var seen = {}, cards = [];
    sec.querySelectorAll('[class*="testimonials-slide-template"]').forEach(function (sl) {
      if (sl.classList.contains('swiper-slide-duplicate')) return;
      var t = sl.querySelector('[class*="slide-heading"]'), xb = sl.querySelector('[class*="slide-text-big"]') || sl.querySelector('[class*="slide-text"] span') || sl.querySelector('[class*="slide-text"]'), a = sl.querySelector('[class*="author-date"]');
      var c = { t: t ? t.textContent.trim() : '', x: xb ? xb.textContent.trim() : '', a: a ? a.textContent.trim() : '', s: sl.querySelectorAll('[class*="testimonials-stars"] svg').length || 5 };
      var k = c.t + '|' + c.a; if (seen[k] || !c.x) return; seen[k] = 1; cards.push(c);
    });
    if (!cards.length) return;
    sec.dataset.b9rev = '1';
    var id = 'b9rv' + n;
    var html = '<div class="b9-rev__in"><h2 class="b9-rev__h">' + (h ? h.innerHTML : '') + '</h2><div class="b9-rev__grid"><div class="b9-rev__sum"><div class="b9-rev__score"><span class="b9-rev__num">' + esc(numEl.textContent.trim()) + '</span><span class="b9-rev__of">/ 5</span></div><div class="b9-rev__stars" role="img" aria-label="Rated ' + r + ' out of 5">' + stars(r, id) + '</div>' + (cntEl ? '<p class="b9-rev__based">Based on <strong>' + esc(cntEl.textContent.trim()) + '</strong> reviews</p>' : '') + '<p class="b9-rev__golfers"><strong>21k+</strong> golfers wear Back9Lab on the course</p></div><div class="b9-rev__slider"><div class="b9-rev__track">' +
      cards.map(function (c, i) { return '<article class="b9-rev__card"><div class="b9-rev__stars" role="img" aria-label="Rated ' + c.s + ' out of 5">' + stars(c.s, id + 'c' + i) + '</div><p class="b9-rev__t">' + esc(c.t) + '</p><p class="b9-rev__x">' + esc(c.x) + '</p><p class="b9-rev__a">' + esc(c.a) + '</p></article>'; }).join('') +
      '</div><div class="b9-rev__nav"><button type="button" class="b9-rev__btn" data-d="-1" aria-label="Previous reviews"><svg viewBox="0 0 20 20" fill="none"><path d="M12.5 4.4 6.9 10l5.6 5.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button><button type="button" class="b9-rev__btn" data-d="1" aria-label="Next reviews"><svg viewBox="0 0 20 20" fill="none"><path d="m7.5 4.4 5.6 5.6-5.6 5.6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div></div></div></div>';
    var box = document.createElement('section'); box.className = 'b9-rev'; box.innerHTML = html;
    src.style.display = 'none';
    sec.appendChild(box);
    var tr = box.querySelector('.b9-rev__track');
    box.querySelectorAll('.b9-rev__btn').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = tr.querySelector('.b9-rev__card'), step = card ? card.getBoundingClientRect().width + 16 : tr.clientWidth;
        var d = +b.getAttribute('data-d');
        if (d > 0 && tr.scrollLeft + tr.clientWidth >= tr.scrollWidth - 4) tr.scrollTo({ left: 0, behavior: 'smooth' });
        else if (d < 0 && tr.scrollLeft <= 4) tr.scrollTo({ left: tr.scrollWidth, behavior: 'smooth' });
        else tr.scrollBy({ left: d * step, behavior: 'smooth' });
      });
    });
  }
  function run() {
    var secs = document.querySelectorAll('[id*="__ss_testimonial_8_"]');
    if (!secs.length) return;
    if (!document.getElementById('b9-rev-css')) { var st = document.createElement('style'); st.id = 'b9-rev-css'; st.textContent = CSS; document.head.appendChild(st); }
    secs.forEach(build);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', run);
})();
